import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
  IconButton,
  OutlinedInput,
  InputLabel,
  InputAdornment,
  FormControl,
  FormHelperText,
  CircularProgress,
  Divider,
} from "@material-ui/core";

import {
  Visibility,
  VisibilityOff,
  WhatsApp,
  LockOutlined,
  Close
} from "@material-ui/icons";

import {
  auth,
  firefunctions,
} from "../../../components/firebase/FirebaseProvider";

import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";

import useStyles from "./style";
import isMobilePhone from "../../../utils/isMobilePhone";

const NumberFormatCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "+",
        /[1-9]/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={false}
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default function LoginPopup({ path, pathName }) {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [values, setValues] = useState({
    phone: "",
    password: "",
  });

  const [isSubmitting, setSubmitting] = useState();

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (prop) => (e) => {
    setValues({
      ...values,
      [prop]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);

    try {
      const { phone, password } = values;
      const exp = /-/g;
      let phoneRaw = phone.replace(exp, "");

      if (!phone) {
        throw new Error("No WhatsApp wajib diisi");
      } else if (!password) {
        throw new Error("Password wajib diisi");
      } else if (!isMobilePhone(phoneRaw)) {
        throw new Error("No Whatsapp tidak valid");
      }

      const loginByPhoneAndPassword = firefunctions.httpsCallable(
        "loginByPhoneAndPassword"
      );
      const response = await loginByPhoneAndPassword({
        no_hp: phoneRaw,
        password,
      });

      await auth.signInWithCustomToken(response?.data?.custom_token ?? "token");
      enqueueSnackbar("berhasil login", {
        variant: "success",
      });

      history.push(path);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
    }

    setSubmitting(false);
  };

  return (
    <>
      <DialogContent className={classes.content}>
        <div style={{
          width: '100%',
          textAlign: 'right'
        }}>
          <Close 
            style={{
              color: 'grey',
              cursor: 'pointer'
            }}
            onClick={history.goBack}
          />
        </div>
        <Typography
          variant="h5"
          align="center"
          style={{
            margin: "20px",
            marginBottom: "10px",
            fontWeight: 'bold'
          }}
        >
          Login
        </Typography>
        <Typography
          variant="subtitle2"
          align="center"
          style={{
            marginBottom: "30px",
          }}
        >
          Untuk melanjutkan, silahkan login.
        </Typography>
        <form className={classes.box_form} onSubmit={handleSubmit}>
          <FormControl
            variant="outlined"
            fullWidth
            className={classes.input_form}
            style={{ marginBottom: "25px" }}
          >
            <InputLabel htmlFor="outlined-adornment-wa">Nomor WA</InputLabel>
            <OutlinedInput
              value={values.phone}
              autoFocus={values.autoFocus}
              id="outlined-adornment-wa"
              label="Nomor WA"
              placeholder="+62-852-1234-5678"
              onChange={handleChange("phone")}
              disabled={isSubmitting}
              inputComponent={NumberFormatCustom}
              startAdornment={
                <InputAdornment position="start">
                  <WhatsApp color="action" />
                </InputAdornment>
              }
            ></OutlinedInput>
            {values.errorStatus ? (
              values.errorType === "wa" ||
              values.errorType === "wa kosong" ||
              values.errorType === "wa invalid" ? (
                <FormHelperText>{values.errorMessage}</FormHelperText>
              ) : null
            ) : null}
          </FormControl>
          <FormControl
            variant="outlined"
            fullWidth
            className={classes.input_form}
            style={{ marginBottom: "25px" }}
            error={
              values.errorStatus
                ? values.errorType === "password" ||
                  values.errorType === "password kosong"
                  ? values.errorStatus
                  : null
                : null
            }
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              label="Password"
              type={values.showPassword ? "text" : "password"}
              value={values.password}
              autoFocus={values.autoFocus}
              onChange={handleChange("password")}
              disabled={isSubmitting}
              startAdornment={
                <InputAdornment position="start">
                  <LockOutlined color="action" />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
              placeholder="Password"
            />
            {values.errorStatus ? (
              values.errorType === "password" ||
              values.errorType === "password kosong" ? (
                <FormHelperText>{values.errorMessage}</FormHelperText>
              ) : null
            ) : null}
          </FormControl>
          <div>
            <div
              style={{
                display: "inline-block",
                textAlign: "right",
                width: "100%",
              }}
            >
              <Link
                to="/login/forgot"
                style={{
                  textDecoration: "none",
                }}
              >
                Lupa password?
              </Link>
            </div>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              style={{
                position: "relative",
                width: "100%",
                letterSpacing: "1px",
                fontWeight: "bold",
                borderRadius: "8px",
                paddingTop: "12px",
                paddingBottom: "12px",
                marginTop: "10px",
                marginBottom: "20px",
              }}
            >
              {isSubmitting === true && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
              {!isSubmitting ? "masuk" : null}
            </Button>
          </div>
        </form>
      </DialogContent>
      <Divider />
      <DialogActions
        style={{
          margin: "20px",
          marginTop: "10px",
          textAlign: "center",
          justifyContent: "center"
        }}
      >
        Belum punya akun?
        <Link
          to={`/register?utm_source=${pathName}`}
          style={{
            textDecoration: "none",
            marginLeft: "5px",
          }}
        >
          Daftar
        </Link>
      </DialogActions>
    </>
  );
}
